module.exports = __webpack_public_path__ + "media/wendy.076fa6bd.wav";